export const getValue = (state, name) => {
  if (!name || !state) return undefined;

  if (name.includes(".")) {
    return name.split(".").reduce((obj, key) => obj?.[key], state);
  }

  return state[name];
};
export const setValue = (state, obj) => {
  const result = { ...state };
  Object.entries(obj).forEach(([key, value]) => {
    if (key.includes(".")) {
      const parts = key.split(".");
      const lastKey = parts.pop();
      const target = parts.reduce((obj, key) => {
        obj[key] = obj[key] || {};
        return obj[key];
      }, result);
      target[lastKey] = value;
    } else {
      result[key] = value;
    }
  });
  return result;
};

export default { getValue, setValue };
